module.exports = __webpack_public_path__ + "static/media/administrator-icon.514158db.svg";